import { z } from 'zod/v4';

import localAxios from '../../localAxios';
import { ActivityInsights, activityInsightsSchema } from './insightSchema';
import { generateActivityInsightsURL } from './URLs';

interface PostGenerateActivityInsightsParams {
  activityInstanceId: number;
}

export async function postGenerateActivityInsights({
  activityInstanceId,
}: PostGenerateActivityInsightsParams): Promise<ActivityInsights> {
  const url = generateActivityInsightsURL(activityInstanceId);
  
  try {
    const response = await localAxios.post<unknown>(url.href);
    const { data, error } = postGenerateActivityInsightsResponse.safeParse(
      response.data
    );
    if (error) {
      console.error(error.message);
      throw error;
    }
    return data.insights;
  } catch (error) {
    // Re-throw axios errors (like rate limits) without validation
    // so they can be properly handled by handleInsightsError
    if (error.isAxiosError || error.response) {
      throw error;
    }
    // For other errors (like zod validation), throw as-is
    throw error;
  }
}

const postGenerateActivityInsightsResponse = z.object({
  insights: activityInsightsSchema,
  message: z.string(),
});
